export default "__VITE_PUBLIC_ASSET__8b0e9e77__"